<template>
    <div class="navigation-bar">
        <div class="container">
            <div class="row">
                <div class="col">
                    <router-link to="/shop" class="w-100 navigation-item">
                        <img src="/assets/dipocaco/icons/shop.png" class="navigation-item-icon" alt="shop-icon"/>
                    </router-link>
                </div>

                <div class="col">
                    <router-link to="/inventory" class="w-100 navigation-item">
                        <img src="/assets/dipocaco/icons/inventory2.png" class="navigation-item-icon" alt="inventory-icon"/>
                    </router-link>
                </div>

                <div class="col">
                    <router-link to="/my-cards" class="w-100 navigation-item">
                        <img src="/assets/dipocaco/icons/mycards.png" class="navigation-item-icon" alt="mycards-icon"/>
                    </router-link>
                </div>

                <div class="col">
                    <a class="w-100 navigation-item" data-bs-toggle="offcanvas" href="#notifications-canvas" role="button" aria-controls="notifications-canvas">
                        <img src="/assets/dipocaco/icons/bell.png" class="navigation-item-icon" alt="notifications-icon"/><span class="badge badge-pill bg-danger ms-1 mb-3" v-if="unreadNotifications.length > 0" v-text="unreadNotifications.length"></span>
                    </a>
                </div>
            </div>

            <div class="offcanvas offcanvas-end" tabindex="-1" id="notifications-canvas" aria-labelledby="#notifications-canvas-label">
                <div class="offcanvas-header px-4">
                    <h5 class="offcanvas-title" id="notifications-canvas-label">Notifications</h5>
                    <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                </div>
                <div class="offcanvas-body px-4">
                    <a v-if="unreadNotifications.length > 0" href="javascript:" class="btn btn-dark w-100 mb-4" v-on:click="markRead()">Mark all as read <i class="fa-solid fa-check"></i></a>

                    <div v-for="notification in $store.state.user.notifications" :class="'alert alert-light '+(notification.is_read ? '' : 'bg-success text-light')">
                        <img v-if="notification.image_url?.length > 0" :src="notification.image_url" class="float-end notification-image">
                        {{ notification.body }}<br/>
                        <br/>
                        <template v-if="notification.link_text?.length > 0">
                            <a :href="notification.link_url" class="btn btn-sm btn-secondary mb-3 w-100" v-text="notification.link_text"></a>
                        </template>
                        <small class="muted text-end mb-2 w-100">
                            {{ getTimestampFrom(notification.created_at) }} | {{ getTimestamp(notification.created_at) }}
                        </small>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "NavigationBar",
    methods: {
        markRead() {
            axios.get('/api/user/notifications/read').then(response => {
                this.$store.commit('updateUserData');
                iziToast.success({title: 'All notifications read'});
            });
        },
        getTimestampFrom(timestamp) {
            return moment(timestamp).fromNow();
        },
        getTimestamp(timestamp) {
            return moment(timestamp).format('YYYY-MM-DD hh:mm');
        },
    },
    computed: {
        unreadNotifications() {
            return this.$store.state.user.notifications.filter(n => !n.is_read);
        }
    }
}
</script>

<style scoped>
.navigation-bar {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 100;
    font-size: 1.2em;
    font-weight: bolder;

    height: 3.5em;
    background-color: white;
    border-top: 1px solid slategrey;
    vertical-align: middle;

    .navigation-item {
        display: inline-block;
        text-align: center;
        text-decoration: none;
        padding: 0.33em;
        margin: 0.4em;
        white-space: nowrap;

        i {
            margin-left: 0.25em;
        }
    }

    div {
        .col:not(:first-child) {
            padding-left: 0;

            .navigation-item {
                border-left: 1px solid grey;
            }
        }

        .col:not(:last-child) {
            padding-right: 0;

            .navigation-item {
                border-right: 1px solid grey;
            }
        }
    }

    .navigation-item-icon {
        max-height: 2em;
    }

    .badge-pill {
        font-size: 1em;
    }

    .notification-image {
        max-width: 25%;
        margin-left: 1em;
        margin-bottom: 1em;
    }
}
</style>
